import mailings from './mailings'
import mailing from './mailing'
import step from './step'

export default {
  mailing: {
    namespaced: true,
    ...mailings,
    modules: {
      entry: mailing,
      step: step,
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/mailings/index.js